import { Button, useDisclosure } from "@chakra-ui/react"
import { CancelSubscriptionAlert } from "./cancelSubscriptionAlert";
import { useBilling } from "lib/hooks";
import { path } from "ramda";

const getStatus = path(['plan', 'status']);

export const CancelSubscription = () => {
  const { data } = useBilling();
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (getStatus(data) !== 'active') {
    return null;
  }

  return (
    <>
      <Button
        size="sm"
        variant="link"
        fontSize="xs"
        textDecoration="underline"
        marginRight="10px"
        onClick={onOpen}
      >
        Cancel subscription
      </Button>
      <CancelSubscriptionAlert isOpen={isOpen} onClose={onClose} />
    </>
  )
}
